(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["jshook"] = factory();
	else
		root["jshook"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createJshook = undefined;
	
	var _createJshook = __webpack_require__(1);
	
	var _createJshook2 = _interopRequireDefault(_createJshook);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Singleton version
	exports.default = (0, _createJshook2.default)();
	
	// Factory version
	
	exports.createJshook = _createJshook2.default;

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
	  var dataKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'jshook';
	
	  // Store hooks
	  var hooks = {};
	
	  // Has alredy booted?
	  var booted = false;
	
	  // Execute given function only when jshook is not alredy booted
	  var whenNotBooted = function whenNotBooted(fn) {
	    return function () {
	      if (booted) {
	        console.warn('Alredy booted, register/unregister or boot actions must be ' + 'performed before booting the first time.');
	        return;
	      }
	      return fn.apply(undefined, arguments);
	    };
	  };
	
	  // Is hook alredy registered?
	  var isRegistered = function isRegistered(key) {
	    return typeof hooks[key] !== 'undefined';
	  };
	
	  // Register hook
	  var register = whenNotBooted(function (key, fn) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    if (isRegistered(key)) {
	      console.warn('The hook for key ' + key + ' is alredy registered, you have to ' + 'explicit unregister them before re-register the hook.');
	      return;
	    }
	    hooks[key] = { fn: fn, options: options };
	  });
	
	  // Unregister hook
	  var unregister = whenNotBooted(function (key) {
	    delete hooks[key];
	  });
	
	  // Boot hooks
	  var boot = whenNotBooted(function () {
	    Array.prototype.slice.call(root.querySelectorAll('[data-' + dataKey + ']')).forEach(function (element) {
	      var key = element.getAttribute('data-' + dataKey);
	
	      if (!isRegistered(key)) {
	        console.warn('No hook defined for key ' + key + '.');
	        return;
	      }
	
	      // TODO: Implement options...
	      var fn = hooks[key].fn;
	
	      fn(element);
	    });
	    // jshook is now booted!
	    booted = true;
	  });
	
	  // jshook lib
	  return { register: register, unregister: unregister, isRegistered: isRegistered, boot: boot };
	};

/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** jshook.js
 **/